import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-page-header",
	templateUrl: "./page-header.component.html",
	styleUrls: ["./page-header.component.scss"],
})
export class PageHeaderComponent implements OnInit {
	@Input() title: string;
	@Input() isBack: boolean = true;
	/**
	 * En-tête d'un enregistrement (demande, bon de commande…) : nom de la collection, numéro ou id
	 * en pastille et grande ligne optionnelle (ex. le projet), dans une carte.
	 * Sans libellé, l'en-tête reste celui des listes et utilise le slot [titles].
	 */
	@Input() libelle: string | null = null;
	@Input() numero: string | number | null = null;
	@Input() sousTitre: string | null = null;
	/** Mobile : les actions restent fixées en bas de l'écran pendant le défilement. */
	@Input() actionsFixesMobile: boolean = false;

	constructor() {}

	ngOnInit() {}
}
